import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "static-body bg-gondola" }
const _hoisted_2 = {
  class: "container mw-1356",
  style: {"max-width":"860px"}
}
const _hoisted_3 = { class: "pp-section" }
const _hoisted_4 = { class: "pp-section" }
const _hoisted_5 = { class: "pp-section" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "pp-section" }
const _hoisted_8 = { class: "pp-section" }
const _hoisted_9 = { class: "pp-section" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarTwo = _resolveComponent("NavbarTwo")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavbarTwo),
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "static-hero" }, [
      _createElementVNode("div", { class: "container mw-1356" }, [
        _createElementVNode("span", { class: "top-title" }, "LEGAL"),
        _createElementVNode("h1", null, "Return & Refund Policy"),
        _createElementVNode("p", null, "Your options if the service isn't right for you")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", null, " This Refund Policy applies to subscriptions purchased from " + _toDisplayString(_ctx.c.tradingName) + " (" + _toDisplayString(_ctx.c.legalName) + "). Because we sell digital streaming subscriptions, the following terms set out when a refund is available. ", 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, "1. " + _toDisplayString(_ctx.c.refund.windowDays) + "-Day Refund Window", 1),
          _createElementVNode("p", null, [
            _cache[0] || (_cache[0] = _createTextVNode(" If you experience a technical problem that prevents you from using the service and our support team is unable to resolve it, you may request a full refund within ")),
            _createElementVNode("strong", null, _toDisplayString(_ctx.c.refund.windowDays) + " days", 1),
            _cache[1] || (_cache[1] = _createTextVNode(" of your purchase. "))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("h2", null, "2. How to Request a Refund", -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _cache[2] || (_cache[2] = _createTextVNode("Contact us at ")),
              _createElementVNode("a", {
                href: 'mailto:' + _ctx.c.support.email
              }, _toDisplayString(_ctx.c.support.email), 9, _hoisted_6),
              _cache[3] || (_cache[3] = _createTextVNode(" with your account email and order reference."))
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("li", null, "Describe the issue so our team can attempt a fix first — most issues are resolved quickly.", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("li", null, "If we cannot resolve it within the window, we will refund your payment to the original card.", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("h2", null, "3. Processing Time", -1)),
          _createElementVNode("p", null, [
            _createTextVNode(" Approved refunds are issued to your original payment method via our payment facilitator, " + _toDisplayString(_ctx.c.payments.facilitator.name) + ". Refunds are processed in ", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.c.payments.currency), 1),
            _cache[7] || (_cache[7] = _createTextVNode(" and typically appear within 5–10 business days, depending on your bank. "))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[14] || (_cache[14] = _createElementVNode("h2", null, "4. Exclusions", -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, "Requests made after the " + _toDisplayString(_ctx.c.refund.windowDays) + "-day window.", 1),
            _createElementVNode("li", null, [
              _cache[10] || (_cache[10] = _createTextVNode("Accounts suspended or terminated for breach of our ")),
              _createVNode(_component_RouterLink, { to: "/terms-conditions" }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("Terms & Conditions")
                ])),
                _: 1
              }),
              _cache[11] || (_cache[11] = _createTextVNode(" (e.g. sharing, resale, fraud)."))
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("li", null, "Issues caused by your own internet connection, hardware or third-party apps where the service itself is functioning.", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("li", null, "Change of mind after the service has been used substantially during the window.", -1))
          ])
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "pp-section" }, [
          _createElementVNode("h2", null, "5. Chargebacks"),
          _createElementVNode("p", null, " Please contact us before initiating a card chargeback — we will always try to make it right. Fraudulent chargebacks may result in account termination. ")
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _cache[17] || (_cache[17] = _createElementVNode("h2", null, "6. Contact", -1)),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.c.legalName) + " · " + _toDisplayString(_ctx.address), 1),
            _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
            (_ctx.c.support.email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _cache[15] || (_cache[15] = _createTextVNode("Email: ")),
                  _createElementVNode("a", {
                    href: 'mailto:' + _ctx.c.support.email
                  }, _toDisplayString(_ctx.c.support.email), 9, _hoisted_11)
                ]))
              : _createCommentVNode("", true),
            (_ctx.c.support.phone)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " · Phone: " + _toDisplayString(_ctx.c.support.phone), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_CopyRight)
  ]))
}